import ReportOverlay from '../components/ReportOverlay'
import Spinner from '../components/Spinner'
import selectList from '../selectors/selectList'
import selectEntity from '../selectors/selectEntity'
import { connect } from 'react-redux'
import { addReportToWorkspace, fetchReport } from '../actions/reportActions'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

@connect(
  mapStateToProps,
  { addReportToWorkspace, fetchReport },
  mergeProps
)
export default class ReportOverlayContainer extends Component {
  static propTypes = {
    addReportToWorkspace: PropTypes.func.isRequired,
    company: PropTypes.object.isRequired,
    fetchReport: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    permissions: PropTypes.object,
    report: PropTypes.object.isRequired,
    searchHighlights: PropTypes.array,
    tags: PropTypes.array.isRequired,
    workspaces: PropTypes.array.isRequired
  }

  componentDidMount() {
    const { company, fetchReport, report } = this.props
    fetchReport(company, report.id)
  }

  render() {
    const {
      addReportToWorkspace,
      company,
      isFetching,
      permissions,
      report,
      searchHighlights,
      tags,
      workspaces
    } = this.props

    if (isFetching) {
      return <Spinner spinning={true} style={{ top: 200 }} />
    }

    return (
      <ReportOverlay
        onAddToWorkspace={workspace =>
          addReportToWorkspace(company, report, workspace)
        }
        permissions={permissions}
        report={report}
        searchHighlights={searchHighlights}
        tags={tags}
        workspaces={workspaces}
      />
    )
  }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { reportId, searchHighlights } = ownProps
  const { company, isFetching, entities, permissions } = stateProps
  const report = selectEntity(entities.reports, reportId)
  const workspaces = selectList(entities.workspaces, report.workspaces)
  const tags = selectList(entities.tags, report.tags)

  return Object.assign({}, dispatchProps, {
    company,
    isFetching,
    permissions,
    report,
    searchHighlights,
    tags,
    workspaces
  })
}

function mapStateToProps(state) {
  return {
    company: state.company,
    isFetching: state.reports.isFetching,
    entities: state.entities,
    permissions: state.permissions
  }
}



// WEBPACK FOOTER //
// ../src/containers/ReportOverlayContainer.js